import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {SharedDataService} from "./shared-data.service";
import {KlasifikatoriusService} from "./klasifikatorius.service";
import {SessionTimerService} from "./session-timer.service";
import {UserDataService} from "./user-data.service";
import {environment} from "../../environments/environment";
import {LanguageService} from "./language.service";

@Injectable({
  providedIn: 'root',
})
export class AppInitializer {
  private gpaisInternalUrl = environment.gpaisInternalUrl;

  constructor(private translateService: TranslateService,
              private sharedDataService: SharedDataService,
              private klasifikatoriusService: KlasifikatoriusService,
              private sessionTimerService: SessionTimerService,
              private userDataService: UserDataService,
              private languageService: LanguageService) {}

  initialize(): Promise<void> {
    return this.initializeUser().then(() => {
      return Promise.all([
        this.initializeSession(),
        this.initializeTranslations(),
        this.initializeKlasifikatorius()
      ]).then(() => {
        console.log('Initialization complete.');
      });
    });
  }

  private initializeTranslations(): Promise<void> {
    const savedLang = localStorage.getItem('appLanguage');
    const initialLanguage = savedLang || 'lt';

    this.translateService.setDefaultLang(initialLanguage);
    this.translateService.use(initialLanguage);
    this.languageService.setLanguage(initialLanguage);

    return Promise.resolve();
  }

  public initializeKlasifikatorius(): Promise<void> {
    return new Promise<void>((resolve: any) => {
      this.klasifikatoriusService.getKlasifikatorius().subscribe(data => {
          this.sharedDataService.setklasifikatoriusApiSubject(data);
          resolve(null);
        },
        error => {
          this.sharedDataService.setKlaidos(error.error);
          resolve(null);
        });
    });
  }

  private initializeSession(): Promise<void> {
    return new Promise<void>((resolve: any) => {
      this.sessionTimerService.getSessionTimeout().subscribe(timeout => {
          this.sharedDataService.setSessionTimeout(timeout);
          this.sessionTimerService.startSessionTimer(timeout);
          resolve(null);
        },
        error => {
          this.sharedDataService.setKlaidos(error.error);
          resolve(null);
        });
    });
  }

  private initializeUser(): Promise<void> {
    return new Promise<void>((resolve: any) => {
      this.userDataService.fetchUserData().subscribe(data => {
          this.sharedDataService.setUserData(data);
          resolve(null);
        },
        error => {
          window.location.href = this.gpaisInternalUrl;
        });
    });
  }
}
